A location node with the given location `id`.

This query accepts browser tokens that include the `query:ontologies` or `query:enhanced-job-posting` scope.
